import classNames from 'classnames'
import { ICON_CHEVRON_RIGHT_PRIMARY } from '../../../modules/svg/svg'

interface SliderNextBtnProps {
  translateX?: number
  right?: string
  top?: string
  onClick?: () => void
}

const SliderNextBtn = ({ translateX, right = '-6px', top = '50%', onClick }: SliderNextBtnProps) => {
  return (
    <div
      className={classNames(
        onClick === null
          ? 'hidden'
          : 'absolute z-10 flex -translate-y-24 transform cursor-pointer items-center justify-center rounded-full bg-white shadow-md',
        translateX ? `translate-x-${translateX}` : ' translate-x-22'
      )}
      style={{ width: '40px', height: '40px', right, top }}
      onClick={onClick}
    >
      <img src={ICON_CHEVRON_RIGHT_PRIMARY} />
    </div>
  )
}

export default SliderNextBtn
